// extracted by mini-css-extract-plugin
export var orderDetails = "_o1-2";
export var orderImage = "_o1-1";
export var orderMeta = "_o1-3";
export var orderSummary = "_o1-0";
export var rightArrow = "_o1-4";